import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { UserService } from './services/common/user.service';
import localeBn from '@angular/common/locales/bn';
import { isPlatformBrowser, isPlatformServer, registerLocaleData } from '@angular/common';
import { AppConfigService } from './services/core/app-config.service';
import { Router, NavigationEnd } from '@angular/router';
import { GtmService } from './services/core/gtm.service';
import { UtilsService } from './services/core/utils.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // Store Data
  isBrowser: boolean;
  isServer: boolean;
  @ViewChild('scroll') scroll: ElementRef;

  // Inject
  private readonly userService = inject(UserService);
  private readonly appConfigService = inject(AppConfigService);
  private readonly router = inject(Router);
  private readonly gtmService = inject(GtmService);
  private readonly utilsService = inject(UtilsService);
  public readonly platform = inject(PLATFORM_ID);

  private subscriptions: Subscription[] = [];
  private eventId: string;

  ngOnInit() {
    this.userService.autoUserLoggedIn();

    registerLocaleData(localeBn, 'bn');
    this.isBrowser = isPlatformBrowser(this.platform);
    this.isServer = isPlatformServer(this.platform);

    // Initialize analytics (Facebook Pixel, GTM, Google Search Console)
    this.appConfigService.loadConfig();

    if (this.isBrowser) {
      const configSub = this.appConfigService.config$.subscribe(config => {
        if (config) {
          this.onChangeRouterEvent();
          this.trackPageViewEvent();
          // Unsubscribe from config$ to prevent repeated bindings
          configSub.unsubscribe();
        }
      });
    }

    this.jj();
  }

  private jj() {

    function productPrice(number) {

      // Extract the integer part
      const integer = Math.floor(number);
      const fractional = number - integer;

      //Converting the fractional to the integer
      const frac2int = (fractional * 100) / 5;
      const fracCeil = Math.ceil(frac2int);

      //transforming inter into fractional
      const FracOut = (fracCeil * 5) / 100;
      const ans = integer + FracOut;

      const finalOutput = (Math.round(ans * 100) / 100).toFixed(2);

    }

    productPrice(21.59878);
  }

  private onChangeRouterEvent() {
    const subscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (isPlatformBrowser(this.platform)) {
          this.trackPageViewEvent();
        }
      }
    });
    this.subscriptions.push(subscription);
  }

  private generateEventId(): void {
    this.eventId = this.utilsService.getRandomInt(1000000000, 9999999999).toString();
  }

  private trackPageViewEvent(): void {
    const analytics = this.appConfigService.getSettingData('analytics');
    const shouldTrackAnalytics =
      this.gtmService.facebookPixelId ||
      this.gtmService.tagManagerId ||
      this.gtmService.isManageFbPixelByTagManager === true;

    if (shouldTrackAnalytics) {
      this.generateEventId();

      const page_url = location.href;
      const page_title = document.title;
      const referrer = document.referrer || undefined;
      const custom_data = { page_url, page_title, referrer };

      // 1) Browser: Facebook Pixel PageView
      if (this.gtmService.facebookPixelId && !this.gtmService.isManageFbPixelByTagManager) {
        this.gtmService.trackByFacebookPixel('PageView', {}, this.eventId);
      }

      // 2) Server: Facebook CAPI PageView
      const eventTime = Math.floor(Date.now() / 1000);
      const payload: any = {
        event_name: 'PageView',
        event_time: eventTime,
        creationTime: eventTime,
        event_id: this.eventId,
        action_source: 'website',
        event_source_url: page_url,
        custom_data,
        user_data: {
          client_ip_address: '127.0.0.1',
          client_user_agent: navigator.userAgent
        }
      };

      this.gtmService.trackPageView(payload).subscribe({
        next: () => {},
        error: (err) => console.error('CAPI PageView Error:', err)
      });

      // 3) GTM dataLayer
      if (this.gtmService.tagManagerId) {
        this.gtmService.pushToDataLayer({
          event: 'page_view',
          event_id: this.eventId,
          page_data: {
            url: page_url,
            title: page_title,
            referrer: referrer,
          },
        });
      }
    }
  }

  /**
   * scrollTop();
   */
  scrollTop() {
    window.scrollTo(0, 0);
  }

  isCheckoutPage(): boolean {
    return this.router.url ? this.router.url.includes('/checkout') : false;
  }

  @HostListener('window:scroll')
  hideShowScrollBtn() {
    if (this.isCheckoutPage()) {
      if (this.scroll && this.scroll.nativeElement) {
        this.scroll.nativeElement.style.display = 'none';
      }
      return;
    }
    if (window.scrollY > 500) {
      if (this.scroll && this.scroll.nativeElement) {
        this.scroll.nativeElement.style.display = 'flex';
      }
    } else {
      if (this.scroll && this.scroll.nativeElement) {
        this.scroll.nativeElement.style.display = 'none';
      }
    }
  }

}
